module.exports = __webpack_public_path__ + "img/product-shot_02_loading.b7a72309.jpg";